import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'cp-inventory-thresholds',
    templateUrl: './inventory-thresholds.component.html',
    styleUrls: ['./inventory-thresholds.component.scss']
})
export class InventoryThresholdsComponent implements OnInit {

    constructor() {
    }

    ngOnInit() {
    }
    public static virtualizationSettings = { itemHeight: 30, pageSize: 100 };
    public showWarehouseTransfers = false;

    public showWindow() {
        this.showWarehouseTransfers = !this.showWarehouseTransfers;
    }

}
